import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getEventsinner } from "../Service/Api";
import FilterContainer from "../utlis/FilterContainer";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";

function EventInner() {
  const [showData, setShowData] = useState(8);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );

  // ✅ Fetch event data (no loading/error states)
  const { data: eventData = [] } = useQuery({
    queryKey: ["getEventsinner"],
    queryFn: getEventsinner,
  });

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthOptions = ["All", ...monthNames];

  // ✅ Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";
    const day = date.getDate().toString().padStart(2, "0");
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  // ✅ Dummy fallback data
  const event_dummy_data = [
    {
      title: "Event Title",
      description: "Event description goes here.",
      venue: "School Campus",
      date: "DD/MM/YYYY",
      time: "--",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/events.jpg",
    },
  ];

  // ✅ Use fallback if API empty
  const eventList =
    Array.isArray(eventData) && eventData.length > 0
      ? eventData
      : event_dummy_data;

  // ✅ Year range options
  const yearRanges = [
    ...new Set(
      eventList
        .map((item) => {
          const d = new Date(item.date);
          return !isNaN(d) ? d.getFullYear().toString() : null;
        })
        .filter(Boolean)
    ),
  ].sort((a, b) => b - a);

  // ✅ Apply filters
  const filterData = eventList.filter((item) => {
    const date = new Date(item.date);
    const itemYear = date.getFullYear().toString();
    const itemMonth = monthNames[date.getMonth()];

    const matchYear = selectedYear === "All" || itemYear === selectedYear;
    const matchMonth = selectedMonth === "All" || itemMonth === selectedMonth;
    const matchSearch =
      item.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchQuery.toLowerCase());

    return matchYear && matchMonth && matchSearch;
  });

  const visibleEvents = [...filterData]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, showData);

  const handleLoadMore = () => setShowData((prev) => prev + 8);

  return (
    <>
      <Breadcrumb>Events</Breadcrumb>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Events</h1>
            </div>
          </div>

          {/* ===== Filters ===== */}
          <FilterContainer
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            yearRanges={yearRanges}
            monthOptions={monthOptions}
            totalCount={filterData.length}
          />
        </div>

        {/* ===== Events Grid ===== */}
        <div className="container">
          <div className="row years year2024 showYear">
            {visibleEvents.length > 0 ? (
              visibleEvents.map((item, index) => (
                <div
                  className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount"
                  key={index}>
                  <div className="eventsnewsbox">
                    <div className="newsboximg">
                      <LazyLoad
                        offset={10}
                        placeholder={
                          <img
                            src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/events.jpg"
                            alt="Loading..."
                            className="img-fluid"
                          />
                        }>
                        <img
                          src={
                            item?.images?.length
                              ? `https://webapi.entab.info/api/image/${item.images[0]}`
                              : "https://webapi.entab.info/api/image/SJSKBUP/public/Images/events.jpg"
                          }
                          className="img-fluid"
                          alt={item.title || "Event"}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://webapi.entab.info/api/image/SJSKBUP/public/Images/events.jpg";
                          }}
                        />
                      </LazyLoad>
                    </div>

                    <div className="newsboxdesc">
                      <div className="newspgh">
                        <h5>{item.title || "Event Title"}</h5>
                        <p>{item.description || "No description available."}</p>
                        <span>
                          <b>Location:</b> {item.venue || "N/A"}
                        </span>
                      </div>

                      <div className="newsdate">
                        <span>
                          <i className="bi bi-calendar"></i>{" "}
                          {formatDate(item.date)}
                        </span>
                        <span>
                          <i className="bi bi-alarm"></i> {item.time || "N/A"}
                        </span>
                        {item?.attachments?.length ? (
                          <Link
                            to={`https://webapi.entab.info/api/image/${item.attachments[0]}`}
                            target="_blank">
                            <i className="bi bi-paperclip"></i>
                          </Link>
                        ) : (
                          <i className="bi bi-paperclip text-muted"></i>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              // ✅ Fallback message (no events)
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount">
                <div className="eventsnewsbox">
                  <div className="newsboximg">
                    <img
                      src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/events.jpg"
                      className="img-fluid"
                      alt="No Events"
                    />
                  </div>
                  <div className="newsboxdesc">
                    <div className="newspgh">
                      <h5>Stay tuned for latest updates</h5>
                      <p>Check back soon for new events and activities.</p>
                      <span>
                        <b>Location:</b> School
                      </span>
                    </div>
                    <div className="newsdate">
                      <span>
                        <i className="bi bi-calendar"></i> DD/MM/YYYY
                      </span>
                      <span>
                        <i className="bi bi-alarm"></i> --
                      </span>
                      <i className="bi bi-paperclip text-muted"></i>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ===== Load More Button ===== */}
          {filterData.length > showData && (
            <div className="text-center mt-4">
              <button
                className="mainbtn button px-4 py-2"
                onClick={handleLoadMore}>
                Load More
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default EventInner;
